import styled from '@emotion/styled';
import { useRef } from 'react';
import { useButton } from 'react-aria';

import { TextSmall } from '../common/text/TextSmall';

import { useUser } from '../../store/users/useUsers.ts';

import { publicUrl } from '../../theme/functions/publicUrl.js';
import { su } from '../../theme/functions/su';
import { motion } from '../../theme/motion';
import { theme } from '../../theme/theme';

export function User(props) {
  const { user } = useUser({ userId: props.userId });

  const ref = useRef();
  const button = useButton(
    {
      elementType: 'div',
      onPress(event) {
        props.onPress?.(event, user);
      },
    },
    ref,
  );

  if (props.placeholder) {
    return (
      <User.Root>
        <User.Avatar src={publicUrl(`img/ph-64.png`)} alt="user-avatar" />
      </User.Root>
    );
  }

  if (user == null) return null;

  return (
    <User.Root {...button.buttonProps} id={user.id}>
      <User.Avatar
        src={user.avatar || publicUrl(`img/ph-64.png`)}
        alt="user-avatar"
        present={user.present}
        asleep={user.asleep}
      />
      {user.asleep && <User.SleepIndicator />}
      <TextSmall textAlign="center">{user.name?.split(' ')[0]}</TextSmall>
    </User.Root>
  );
}

User.Root = styled.div`
  --transform-transition: transform ease-in-out ${motion.duration.fast};

  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  width: ${su(8)};
  cursor: pointer;
  transition: var(--transform-transition);
  outline: 0;

  &:hover:not([disabled]) {
    transform: scale(1.05);

    &:active:not([disabled]) {
      transform: scale(1);
    }
  }
`;

User.Avatar = styled.img`
  width: ${su(8)};
  height: ${su(8)};
  margin-bottom: ${su(1)};
  border-radius: 50%;
  opacity: ${({ present }) => (present ? 1 : 0.5)};
  box-shadow: ${theme.boxShadow.default};
`;

User.SleepIndicator = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 5px;
  border-radius: 100%;
  background: ${theme.color.white};
  box-shadow: ${theme.boxShadow.default};
  font-size: 9px;

  :before {
    content: 'Zzz';
    color: ${theme.color.text_black};
  }
`;
